// Per-device "last open page" state. Persisted as an encrypted user blob of this
// type and restored after login (see components/NavigationStateSync). The blob's
// `data` is an opaque AES-GCM payload — the server never sees the plaintext path.
export const NAVIGATION_STATE_BLOB_TYPE = 'navigation_state';

// Restore the last page only if the user's last action was within this window.
// Mirrors the VITE_REAUTH_INTERVAL pattern (seconds in env → ms here).
export const NAV_RESTORE_TTL_MS = (import.meta.env.VITE_NAV_RESTORE_TTL || 5 * 60) * 1000;

// Id of this device's navigation-state blob for the current page load. Kept here
// (not in Redux) so both the React sync component and the hardSignout thunk can
// reach it. Reset on reload — restore re-populates it from the login response.
let navBlobId = null;

export const getNavBlobId = () => navBlobId;

export const setNavBlobId = (id) => {
  navBlobId = id;
};
